<div class="alert alert-danger" *ngIf="noUser">
  No user found !
</div>
<div class="alert alert-success" *ngIf="userFound">
  Please select from user dropdown
</div>
<div class="alert alert-success" *ngIf="diUpdateSuccess">
  Banner Image saved successfully!
</div>
<div class="alert alert-success" *ngIf="deleteSuccess">
  Banner image deleted successfully!
</div>
<div class="alert alert-success" *ngIf="diNewsSuccess && saveNews">
  News saved successfully!
</div>
<div class="alert alert-success" *ngIf="diResourceSuccess && saveResource">
  Resource saved successfully!
</div>
<div class="alert alert-success" *ngIf="diReteamSuccess && saveReTeam">
  Regional team saved successfully!
</div>
<div class="alert alert-success" *ngIf="diNaacSuccess && saveNaac">
  NAAC saved successfully!
</div>

<div class="alert alert-success" *ngIf="diNewsSuccess && saveAndUpdateNews">
  News updated successfully!
</div>
<div class="alert alert-success" *ngIf="diResourceSuccess && saveAndUpdateResource">
  Resource updated successfully!
</div>
<div class="alert alert-success" *ngIf="diReteamSuccess && saveAndUpdateReTeam">
  Regional team updated successfully!
</div>
<div class="alert alert-success" *ngIf="diNaacSuccess && saveAndUpdateNaac">
  NAAC updated successfully!
</div>

<div class="alert alert-success" *ngIf="deleteNews">
  News deleted successfully!
</div>
<div class="alert alert-success" *ngIf="deleteResource">
  Resource deleted successfully!
</div>
<div class="alert alert-success" *ngIf="deleteRegional">
  Regional team deleted successfully!
</div>
<div class="alert alert-success" *ngIf="deleteNaac">
  NAAC deleted successfully!
</div>
<div class="alert alert-danger" *ngIf="errorMessageResourceActive">{{errorMessageResource}}
</div>
<div class="alert alert-danger" *ngIf="errorMessageRegionalActive">{{errorMessageRegional}}
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="alert alert-danger" *ngIf="errorMsgUploadSave">
  Uploading failed and data will not be saved!
</div>
<div class="alert alert-danger" *ngIf="errorMsgUploadSaveUpdate">
  Uploading failed and updated data will not be saved!
</div>

<div class="di-container">

  <div>
    <h5>CONFIGURE D+I SITE</h5>
  </div>

  <div class="col-md-3 divfloat margin-top">
    <ul class="nav flex-column nav-pills" role="tablist">
      <li class="nav-item">
        <a id="BannerImage" class="nav-link active" data-toggle="pill" href="#home" (click)="diMaster()">Banner
          Image</a>
      </li>
      <li class="nav-item">
        <a class="nav-link " data-toggle="pill" href="#menu1" (click)="diNews()">Latest BPG News</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="pill" href="#menu2" (click)="diResource()">Additional BPG Resources</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="pill" href="#menu3" (click)="diReTeam()">Regional Engagement Team</a>
      </li>
      <!-- <li class="nav-item">
        <a class="nav-link" data-toggle="pill" href="#menu4" (click)="diNaac()">NAAC</a>
      </li> -->
    </ul>
  </div>

  <!-- Entering fields starts here -->
  <div class="tab-content divfloat col-md-8">


    <div id="home" class="container tab-pane active"><br>
      <form (ngSubmit)="onDiMasterSubmitBanner()" action="" name="diMasterForm" #myFormMaster="ngForm"
        enctype="multipart/form-data">

        <!-- banner tab starts -->
        <!-- 
        <div class="form-group">
          <label class="sitelabel" for="bannerName">Name <span class="star"> *</span></label>
          <input type="text" class="form-control" id="bannerName" name="bannerName" [(ngModel)]="bannerName"
            maxlength="50" placeholder="Enter Name" autocomplete="off" required>
        </div> -->

        <!-- <div class="form-group">
          <label class="sitelabel" for="aboutDesc">About Description
            <span class="star"> *</span>
            <label class="validation-error-message" *ngIf="aboutDesc.length>=2000">
              Only a maximum of 2000 characters are allowed
            </label>
          </label>
          <div class="ckeditor-style val-margin">
            <ckeditor [(ngModel)]="aboutDesc" id="aboutDesc" #myckeditor="ngModel" name="aboutDesc" maxlength="2000"
              [config]="removeToolbar" [readonly]="false" required>
            </ckeditor>
          </div>
        </div> -->

        <div class="form-group">
          <label class="sitelabel bannerupload " for="diBanner">Upload Banner <span class="star"> *</span>
            <p class="placeholder-class">( JPEG or PNG)</p>
          </label>
          <input #myInputBanner type="file" class="form-control inputfile inputfile-6" id="diBanner" name="diBanner"
            maxlength="200" [(ngModel)]="diBanner" (change)="fileChangeEvent($event, 'bannerImage')" accept="image/*"
            [required]="diId == '0'" [attr.disabled]="isUploadImage == true ? true : null">
          <label for="diBanner" class="label-overflow"><span id="filenameBanner" class="ellipsis">JPEG or
              PNG</span><strong><img *ngIf="!isUploadImage" alt="Angular Logo" src="assets/images/upload-button.png" /></strong></label>
          <textarea class="form-control base64textarea" id="base64textarea"></textarea>
        </div>

        <div class="form-group" *ngIf="isUploadImage">
          <label class="sitelabel bannerupload" for="siteBanner"></label>
          <div class="pull-left">
            <div class="loader_ajax_small" [hidden]="isLoaderStop"></div>
            <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="1366/400" [maintainAspectRatio]="true"
              [resizeToWidth]="1366" [resizeToHeight]="400" [onlyScaleDown]="true" format="png"
              (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()" [imageQuality]="92"></image-cropper>
          </div>
        </div>
        <div class="form-group" *ngIf="isLoaderStop">
          <label class="sitelabel bannerupload" for="siteBanner"></label>
          <div class="pull-left">
            <a (click)="doneUploadedImage('bannerImage')"><span class="uploadImageClass"><i
                  class="fa fa-check"></i>&nbsp;Done</span></a>
            &nbsp;&nbsp;<a (click)="cancelUploadedImage('bannerImage')"><span class="uploadImageClass"><i
                  class="fa fa-close"></i>&nbsp;Cancel</span></a>
          </div>
        </div>

        <!--Error message starts -->
        <p class="errorMessage" *ngIf="uploadFileExtensionBanner"> You can only upload jpg, jpeg, png files</p>
        <!-- banner tab close -->


        <div class="btn-div alignment">
          <button type="submit" name="diMasterForm" class="btn btn-danger" data-toggle="modal" data-target="#myModal"
            [disabled]="(uploadFileExtensionBanner || !uploadImageDone)">ADD TO GALLERY</button>
          <p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
          <div>
            <div id="tabledemo1" class="table-contents">
              <div class="table-container1">
                <div class="top-margin">
                   <div class="box"
                    *ngFor="let data of bannerResponseList ;let i=index ">

                    <div class="text1"><a downloadAttachments-btn id='downloadFiles{{i}}'
                        (click)="downloadDocument(data.diName,i)">
                        <img
                          *ngIf="(data.diName.toLowerCase().indexOf('.pdf') !== -1) || (data.diName.toLowerCase().indexOf('.txt') !== -1) || (data.diName.toLowerCase().indexOf('.xls') !== -1) || (data.diName.toLowerCase().indexOf('.xlsx') !== -1) || (data.diName.toLowerCase().indexOf('.doc') !== -1) || (data.diName.toLowerCase().indexOf('.docx') !== -1) || (data.diName.toLowerCase().indexOf('.ppt') !== -1) || (data.diName.toLowerCase().indexOf('.pptx') !== -1)"
                          src="assets/images/download-button.png" alt="Angular Logo" class="image delete-icon download-icon"
                          title="Download"></a>
                    </div>
                    <div class="text1 width-delete"><img src="assets/images/delete.png" alt="Angular Logo" class="image delete-icon"
                        title="Delete" data-toggle="modal" data-target="#myModal"
                        (click)="deleteBannerConfirmation(data.diId)"></div>
                    <img class="image-box-style"
                      *ngIf="(data.diName.toLowerCase().indexOf('.jpg') !== -1) ||(data.diName.toLowerCase().indexOf('.png') !== -1) || (data.diName.toLowerCase().indexOf('.jpeg') !== -1)"
                      src="{{data.diName}}" alt="Angular Logo">
                    <img class="image-box-style"
                      *ngIf="(data.diName.toLowerCase().indexOf('.mov') !== -1) || (data.diName.toLowerCase().indexOf('.mp4') !== -1) || (data.diName.toLowerCase().indexOf('.ogg') !== -1)"
                      src="assets/images/video.jpg" alt="Angular Logo">
                    <img class="image-box-style" *ngIf="(data.diName.toLowerCase().indexOf('.pdf') !== -1)"
                      src="assets/images/pdf.png" alt="Angular Logo">
                    <img class="image-box-style" *ngIf="(data.diName.toLowerCase().indexOf('.txt') !== -1)"
                      src="assets/images/txt.png" alt="Angular Logo">
                    <img class="image-box-style"
                      *ngIf="(data.diName.toLowerCase().indexOf('.doc') !== -1) || (data.diName.toLowerCase().indexOf('.docx') !== -1)"
                      src="assets/images/doc.png" alt="Angular Logo">
                    <img class="image-box-style"
                      *ngIf="(data.diName.toLowerCase().indexOf('.xls') !== -1) || (data.diName.toLowerCase().indexOf('.xlsx') !== -1)"
                      src="assets/images/xls.png" alt="Angular Logo">
                    <img class="image-box-style"
                      *ngIf="(data.diName.toLowerCase().indexOf('.ppt') !== -1) || (data.diName.toLowerCase().indexOf('.pptx') !== -1)"
                      src="assets/images/ppt.png" alt="Angular Logo">

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </form>

    </div>

    <div id="menu1" class="container tab-pane fade"><br>
      <form (ngSubmit)="onNewsSubmit()" action="" name="diNewsForm" #myFormNews="ngForm" enctype="multipart/form-data">

        <!-- News tab starts -->
        <div class="form-group">
          <label class="sitelabel" for="newsTitle">News Title <span class="star"> *</span></label>
          <input type="text" class="form-control" id="newsTitle" name="newsTitle" [(ngModel)]="newsTitle"
            maxlength="200" placeholder="Enter news title" required autocomplete="off">
        </div>

        <div class="form-group">
          <label class="sitelabel" for="newsDesc">News Description </label>
          <textarea class="form-control" id="newsDesc" name="newsDesc" placeholder="Enter description" maxlength="500"
            rows="4" [(ngModel)]="newsDesc" autocomplete="off"></textarea>
        </div>

        <div class="form-group">
          <label class="sitelabel" for="newsLink">News Link </label>
          <!-- <input type="text " class="form-control link-area-https" (keyup)="onLinkType($event,'news')" id="newsLink" name="newsLink"
        [(ngModel)]="newsLink" maxlength="200" placeholder="Enter link" required autocomplete="off"> -->
          <input type="text " class="form-control" (keyup)="onLinkType($event,'news')" id="newsLink" name="newsLink"
            [(ngModel)]="newsLink" maxlength="200" placeholder="Enter link" autocomplete="off">

        </div>
        <div class="form-group">
          <label class="newslabel" for="UploadDocument">Upload Image
            <p class="placeholder-class">( JPEG or PNG)</p>
          </label>
          <input type="file" id="newsImage" (change)="onFileSelectedNews($event)" [(ngModel)]="newsImage"
            name="newsImage" placeholder="JPEG or PNG" class="form-control input-lg upload-icon hideInput">
          <a class="deleteButton delete-button-style zoom-in-style" title="delete" (click)="removeFile()"><img
              src="assets/images/delete.png" alt="Angular Logo" class="image"></a>
          <label class="form-control input-lg upload-icon file-name-padding label-overflow" for="newsImage"><label
              class="docNameEllipsis resource-ellipsis">{{selectedFileNameforNews}}</label>
            <textarea class="form-control base64textarea" id="base64textareaNews"></textarea>
          </label>
        </div>
        <div class="main-section">
          <p class="errorMessage" *ngIf="newsExtensionError"> Please upload files only in jpeg and png formats</p>
        </div>

        <!--Error message starts -->
        <div class="main-section">
          <p class="errorMessage" *ngIf="newsLinkValid"> Enter valid link</p>
        </div>
        <!-- News tab close -->
        <div class="clear"></div>
        <div class="btn-div alignment">
          <button type="submit" name="diNewsForm" class="btn btn-danger margin-save" name="form2" data-toggle="modal"
            *ngIf="saveNews" data-target="#myModal"
            [disabled]="!myFormNews.valid || newsLinkValid == true || newsExtensionError">SAVE</button>
          <button type="submit" name="diNewsForm" class="btn btn-danger margin-save" *ngIf="saveAndUpdateNews"
            data-toggle="modal" data-target="#myModal"
            [disabled]="!myFormNews.valid || newsLinkValid == true || newsExtensionError">SAVE AND
            UPDATE</button>
          <button type="button" class="btn btn-danger margin-save" name="diNewsForm" (click)="resetNews()"
            data-toggle="modal" data-target="#myModal">RESET</button>
        </div>
      </form>
    </div>
    <div id="menu2" class="container tab-pane fade"><br>
      <form (ngSubmit)="onResourceSubmit()" action="" name="diResourceForm" #myFormResource="ngForm"
        enctype="multipart/form-data">

        <!-- Additional BPG resources tab starts -->
        <div class="form-group">
          <label class="sitelabel" for="addResouceTitle">Resource Title <span class="star"> *</span></label>
          <input type="text" class="form-control" id="addResouceTitle" name="addResouceTitle"
            [(ngModel)]="addResouceTitle" maxlength="200" placeholder="Enter resource title" autocomplete="off"
            required>
        </div>

        <div class="form-group">
          <label class="sitelabel" for="additionalDesc">Description </label>
          <textarea class="form-control" id="additionalDesc" name="additionalDesc"
            placeholder="Enter additional resources description" maxlength="500" [(ngModel)]="additionalDesc" rows="4"
            autocomplete="off"></textarea>
        </div>

        <div class="form-group">
          <label class="sitelabel" for="UploadDocument">Upload Document<span class="star"> *</span></label>

          <input type="file" id="UploadDocument" (change)="onFileSelected($event)" onclick="value = null"
            name="UploadDocument" placeholder="Upload" class="form-control input-lg upload-icon hideInput">
          <label class="form-control input-lg upload-icon file-name-padding label-overflow" for="UploadDocument"><label
              class="docNameEllipsis resource-ellipsis">{{ResourcefileName}}</label>
          </label>


        </div>
        <div class="form-group">

          <label class="selectFolder">Select Folder <span class="star"> *</span></label>
          <ng-select class="folder-size" placeholder="--Select Folder--" [items]="folderNameList" name="folderNameList"
            bindLabel="folderName" bindValue="folderId" [(ngModel)]="selectedFolder" required>
            <!-- <option value="{{siteName}}">Select Site</option> -->
            <!-- <ng-option *ngFor="let folder of folderNameList" [ngValue]="folder.folderName">{{folder.folderName}}</ng-option> -->
          </ng-select>
          <a class="manage-folder-link" routerLink='../additionalresource-folder'>Manage Folder</a>
        </div>
        <div class="form-group">
          <label class="sitelabel" for="resourceOrder">File Order<span class="star"> *</span></label>
          <input type="number" class="form-control" id="resourceOrder" name="resourceOrder"
            onkeypress="return !((event.charCode == 46||event.charCode == 101||event.charCode == 69)) && (event.charCode >= 48 && event.charCode <= 57)"
            [(ngModel)]="resourceOrder" placeholder="Enter file order" required autocomplete="off">
        </div>



        <div class="main-section">
          <p class="errorMessage" *ngIf="fileSizeExtensionError">You can only upload the
            file of size less than 500 MB </p>
        </div>
        <!--news tab close -->
        <div class="clear"></div>

        <div class="btn-div alignment">
          <button type="submit" name="diResourceForm" class="btn btn-danger margin-save" data-toggle="modal"
            data-target="#myModal"
            [disabled]="(!myFormResource.valid || isFileUploded == false )  || fileSizeExtensionError"
            *ngIf="saveResource">SAVE</button>
          <button type="submit" name="diResourceForm" class="btn btn-danger margin-save" *ngIf="saveAndUpdateResource"
            data-toggle="modal" data-target="#myModal"
            [disabled]="(!myFormResource.valid || isFileUploded == false )  || fileSizeExtensionError">SAVE AND
            UPDATE</button>
          <button type="button" class="btn btn-danger margin-save" name="diResourceForm" (click)="resetResource()"
            data-toggle="modal" data-target="#myModal">RESET</button>
        </div>
      </form>

    </div>

    <div id="menu3" class="container tab-pane fade"><br>

      <!-- Regional Engagement Team tab starts -->

      <div class="search-section">

        <div class="search-tag"><input type="text" class="form-control placeholder-class-search width-class "
            maxlength="50" placeholder="Search by first name, last name and email id" [(ngModel)]="searchTerm"
            id="searchTerm" name="searchTerm" autocomplete="off" />
          <!-- <a (click)="searchBy()" class="image-search">
            <img src="assets/images/search.png" (click)="searchBy()"/></a> -->
          <button type="button" class="btn btn-danger image-search" (click)="searchBy()">SEARCH</button>

        </div>
      </div>
      <form (ngSubmit)="onReTeamSubmit()" class="padding-class" onkeypress="return !(event.charCode == 13)" action=""
        name="diRegionalForm" #myFormReTeam="ngForm" enctype="multipart/form-data">


        <div class="form-group">
          <label class="sitelabel" for="userName">Name <span class="star"> *</span></label>
          <ng-select placeholder="Select user" name="userName" class="custom user-width" [items]="userList"
            [disabled]="noUser || butDisabled" bindLabel="userFirstName" Value="userId" [(ngModel)]="userFirstName"
            (change)="userSelection($event)" required>
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <div>{{item.userFirstName}}</div>
              <div *ngIf="item.division" style="font-size: 11px">{{item.division}}</div>
              <div *ngIf="item.classification" style="font-size: 11px">{{item.classification}}</div>
            </ng-template>
          </ng-select>
        </div>

        <div class="form-group">
          <label class="sitelabel" for="regionalDesignation">Role Name <span class="star"> *</span></label>
          <input type="text" class="form-control" id="regionalDesignation" name="regionalDesignation"
            [(ngModel)]="regionalDesignation" placeholder="Enter role name" required autocomplete="off" maxlength="50">
        </div>



        <div class="form-group">
          <label class="sitelabel" for="emailId">Email Id <span class="star"> *</span></label>
          <input type="text" class="form-control" id="emailId" name="emailId" [(ngModel)]="emailId"
            [readonly]="noUser || butDisabled" (keyup)="onEmailType($event)" placeholder="Enter email id" required
            maxlength="50">
        </div>


        <div class="form-group">
          <label class="sitelabel" for="diPronoun">Pronouns </label>
          <input type="text" class="form-control" id="diPronoun" name="diPronoun" [(ngModel)]="diPronoun"
            placeholder="Enter Pronouns" maxlength="50">

        </div>

        <!-- <div class="form-group">
          <label class="sitelabel" for="userName">Site <span class="star"> *</span></label>
          <ng-select placeholder="Select user" name="userName" class="custom user-width" [items]="userList"
            [disabled]="noUser || butDisabled" bindLabel="userFirstName" Value="userId" [(ngModel)]="userFirstName"
            (change)="userSelection($event)" required></ng-select>
        </div> -->

        <div class="form-group">
          <label class="sitelabel" for="siteName">Site </label>
          <ng-select placeholder="Select site" name="userName" class="custom user-width" [items]="siteList"
            bindLabel="siteName" Value="siteName" [(ngModel)]="siteName" multiple="true"></ng-select>
        </div>


        <div class="form-group">
          <label class="sitelabel bannerupload" for="userPic">Upload Image<span class="star"> *</span></label>
          <input #myInput type="file" class="form-control inputfile inputfile-6" id="userPic" name="userPic"
            maxlength="200" [(ngModel)]="userPic" (change)="fileChangeEvent($event, 'userPic')" accept="image/*"
            [required]="userPic == null" [attr.disabled]="isUploadUserPicImage == true ? true : null">
          <label for="userPic" class="label-overflow"><span id="filenameUserPic" class="ellipsis">JPEG or
              PNG</span><strong><img *ngIf="!isUploadUserPicImage" alt="Angular Logo"
                src="assets/images/upload-button.png" /></strong></label>
          <textarea class="form-control base64textarea" id="base64textareaUser"></textarea>
        </div>
        <div class="form-group" *ngIf="isUploadUserPicImage">
          <label class="sitelabel bannerupload" for="userPic"></label>
          <div class="pull-left">
            <div class="loader_ajax_small" [hidden]="isLoaderUserPicStop"></div>
            <image-cropper [imageChangedEvent]="imageChangedEvent" [aspectRatio]="400/400" [maintainAspectRatio]="true"
              [resizeToWidth]="400" [resizeToHeight]="400" [onlyScaleDown]="true" format="png"
              (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()" [imageQuality]="92"></image-cropper>
          </div>
        </div>
        <div class="form-group" *ngIf="isLoaderUserPicStop">
          <label class="sitelabel bannerupload" for="userPic"></label>
          <div class="pull-left">
            <a (click)="doneUploadedImage('userPic')"><span class="uploadImageClass"><i
                  class="fa fa-check"></i>&nbsp;Done</span></a>
            &nbsp;&nbsp;<a (click)="cancelUploadedImage('userPic')"><span class="uploadImageClass"><i
                  class="fa fa-close"></i>&nbsp;Cancel</span></a>
          </div>
        </div>
        <div class="form-group">
          <label class="sitelabel" for="reTeamOrder">Order<span class="star"> *</span></label>
          <input type="number" class="form-control" id="reTeamOrder" name="reTeamOrder"
            onkeypress="return !((event.charCode == 46||event.charCode == 101||event.charCode == 69)) && (event.charCode >= 48 && event.charCode <= 57)"
            [(ngModel)]="reTeamOrder" placeholder="Enter order" required autocomplete="off">
        </div>

        <div class="main-section">
          <p class="errorMessage" *ngIf="uploadFileExtensionUser"> You can only upload jpg, jpeg, png files</p>
          <p class="errorMessage" *ngIf="reTeamEamilValid"> Enter valid email</p>

        </div>
        <!-- regional team tab close -->
        <div class="clear"></div>

        <div class="btn-div alignment">
          <button type="submit" id="saveReTeam" name="diRegionalForm" class="btn btn-danger margin-save"
            [disabled]="!myFormReTeam.valid || reTeamEamilValid  || uploadUserPicImageDone || uploadFileExtensionUser"
            *ngIf="saveReTeam">SAVE</button>
          <button name="diRegionalForm" id="UpdateReTeam" class="btn btn-danger margin-save" *ngIf="saveAndUpdateReTeam"
            [disabled]="!myFormReTeam.valid || reTeamEamilValid || uploadUserPicImageDone || uploadFileExtensionUser">SAVE
            AND UPDATE</button>
          <button type="button" class="btn btn-danger margin-save" name="diRegionalForm" (click)="resetReTeam()"
            data-toggle="modal" data-target="#myModal">RESET</button>
        </div>
      </form>
    </div>

    <div id="menu4" class="container tab-pane fade"><br>
      <form (ngSubmit)="onNaacSubmit()" action="" name="diNaacForm" #myFormNaac="ngForm" enctype="multipart/form-data">

        <!-- NAAC tab starts -->
        <!-- <div class="form-group">
          <label class="sitelabel" for="naacName">Affiliate Name <span class="star"> *</span></label>
          <input type="text" class="form-control" id="naacName" name="naacName" [(ngModel)]="naacName" maxlength="100"
            placeholder="Enter NAAC name" required autocomplete="off">
        </div>

        <div class="form-group">
          <label class="sitelabel bannerupload " for="naacLogo">Logo <span class="star"> *</span></label>
          <input type="file" class="form-control inputfile inputfile-6" id="naacLogo" name="naacLogo" maxlength="200"
            [(ngModel)]="naacLogo" (change)="onNaacSelected($event)" accept="image/*" [required]="naacLogo == null">
          <label for="naacLogo" class="label-overflow"><span id="filenameNaac" class="ellipsis">JPEG or PNG (80 x
              60)</span><strong><img src="assets/images/upload-button.png" /></strong></label>
          <textarea class="form-control base64textarea" id="base64textareaNaac"></textarea>
        </div>

        <div class="form-group">
          <label class="sitelabel" for="naacLink">Sharepoint Link </label>
          <input type="text" class="form-control" id="naacLink" name="naacLink" (keyup)="onLinkType($event,'naac')"
            [(ngModel)]="naacLink" maxlength="200" placeholder="Enter link" autocomplete="off">
        </div>
        <!--Error message starts -->
        <div class="main-section">
          <p class="errorMessage" *ngIf="uploadFileExtensionNaac">You can only upload jpg, jpeg, png files having width
            less than 80 px </p>
          <p class="errorMessage" *ngIf="naacLinkValid"> Enter valid link</p>
        </div> -->
        <!-- News tab close -->

        <div class="clear"></div>

        <div class="btn-div alignment">
          <button type="submit" id="saveNaac" name="diNaacForm" class="btn btn-danger margin-save" name="form5"
            [disabled]="!myFormNaac.valid || naacLinkValid " *ngIf="saveNaac">SAVE</button>
          <button type="submit" id="UpdateNac" name="diNaacForm" class="btn btn-danger margin-save" name="form5"
            *ngIf="saveAndUpdateNaac" [disabled]="!myFormNaac.valid || naacLinkValid">
            SAVE AND UPDATE</button>
          <button type="button" class="btn btn-danger margin-save" name="diNaacForm" (click)="resetNaac()"
            data-toggle="modal" data-target="#myModal">RESET</button>
        </div>
      </form>

    </div>


  </div>
  <div class="clear"></div>

  <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param,param1)" id="2"></app-confirmation-modal>
</div>
<!-- </form> -->
<div class="outer-div" *ngIf="diMasterTable == false && diNewsTable == true">
  <div class="searchBox">
    <label for="search">Search</label>
    <input type="text" class="form-control" id="newsSearchKey" maxlength="50" placeholder="Search by news title"
      [(ngModel)]="newsSearchKey" (keyup.enter)="searchNewsMe()" autocomplete="off">
  </div>
</div>
<div class="outer-div" *ngIf="diMasterTable == false && diResourceTable == true">
  <div class="searchBox">
    <label for="search">Search</label>
    <input type="text" class="form-control" id="resourceSearchKey" maxlength="50" placeholder="Search by resource title"
      [(ngModel)]="resourceSearchKey" (keyup.enter)="searchResourceMe()" autocomplete="off">
  </div>
</div>

<div class="outer-div" *ngIf="diMasterTable == false && diReTeamTable == true">
  <div class="searchBox">
    <label for="search">Search</label>
    <input type="text" class="form-control placeholder-class-search" id="reTeamSearchKey" maxlength="50"
      placeholder="Search by name, role name and email id" [(ngModel)]="reTeamSearchKey"
      (keyup.enter)="searchReTeamMe()" autocomplete="off">
  </div>
</div>
<div class="outer-div" *ngIf="diMasterTable == false && diNaacTable == true">
  <div class="searchBox">
    <label for="search">Search</label>
    <input type="text" class="form-control" id="naacSearchKey" maxlength="50" placeholder="Search by affiliate name"
      [(ngModel)]="naacSearchKey" (keyup.enter)="searchNaacMe()" autocomplete="off">
  </div>
</div>


<!-- table for di news -->
<div id="menu1" class="table-padding" *ngIf=" diNewsTable">
  <div class="table-container horizontal-scroll">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <!-- <th (click)="sortMe('category')">Category <span class="sortupdown"><i id="category1"
            class="fa fa-sort-up"></i><i id="category2" class="fa fa-sort-down"></i></span></th> -->
          <th scope="col">News Title</th>
          <th scope="col">News Link</th>
          <th scope="col" class="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of diNewsList  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
          <td class="news-ellipsis">{{data.diNewsTitle}}</td>
          <td class="news-ellipsis">{{data.diNewsLink}}</td>
          <td class="col-display">{{data.diNewsId}}</td>
          <td>
            <a id="editN{{i}}" (click)="editNews(data,i)" class="edit-delete"><img alt="Angular Logo" src="assets/images/edit.png"
                class="image" title="Edit"></a>
            <a class="edit-delete" id=deleteDi{{i}} (click)="deleteDi(data.diNewsId,'news',i)"><img
                src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
          </td>
        </tr>

      </tbody>
    </table>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElementsNews}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageNewsChanged($event)">
    </pagination-controls>
  </div>
</div>

<!-- table for di resource -->

<div id="menu2" class="table-padding" *ngIf=" diResourceTable">
  <div class="table-container horizontal-scroll">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <!-- <th (click)="sortMe('category')">Category <span class="sortupdown"><i id="category1"
            class="fa fa-sort-up"></i><i id="category2" class="fa fa-sort-down"></i></span></th> -->
          <th scope="col">File Order</th>
          <th scope="col">Resource Title</th>
          <th scope="col">Folder Order</th>

          <th scope="col">Folder Name</th>
          <th scope="col" class="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of diResouceList  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
          <td>{{data.resourceOrder}}</td>

          <td>{{data.diResourceTitle}}</td>
          <td class="folderorder">{{data.folderOrder}}</td>
          <td>{{data.folderName}}</td>

          <!-- <td class="news-ellipsis">{{data.folderName}}</td> -->
          <!-- <td class="col-display">{{data.diResourceId}}</td> -->

          <td>
            <a id="editR{{i}}" (click)="editResource(data,i)" class="edit-delete"><img src="assets/images/edit.png"
                class="image" title="Edit" alt="Angular Logo"></a>
            <a class="edit-delete" id=deleteDi{{i}} (click)="deleteDi(data.diResourceId,'resource',i)"><img
                src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
          </td>
        </tr>

      </tbody>
    </table>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElementsResource}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageResourceChanged($event)">
    </pagination-controls>
  </div>
</div>

<div id="menu3" class="table-padding" *ngIf=" diReTeamTable">
  <div class="table-container horizontal-scroll">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <!-- <th (click)="sortMeReteam('regionalOrder')">Order <span class="sortupdown"><i id="reTeamOrder1"
            class="fa fa-sort-up"></i><i id="reTeamOrder2" class="fa fa-sort-down"></i></span></th>  -->
          <th scope="col">Order</th>
          <th scope="col">Name</th>
          <th scope="col">Role Name</th>
          <th scope="col">Email Id</th>

          <th scope="col" class="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of diReTeamList  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
          <td>{{data.regionalOrder}}</td>
          <td>{{data.userName}}</td>
          <td>{{data.roleName}}</td>
          <td>{{data.emailId}}</td>
          <td class="col-display">{{data.diReTeamId}}</td>

          <td>
            <a id="editRt{{i}}" (click)="editReTeam(data,i)" class="edit-delete"><img src="assets/images/edit.png"
                class="image" title="Edit" alt="Angular Logo"></a>
            <a class="edit-delete" id=deleteDi{{i}} (click)="deleteDi(data.diReTeamId,'regional',i)"><img
                src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
          </td>
        </tr>

      </tbody>
    </table>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElementsReTeam}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageReteamChanged($event)">
    </pagination-controls>
  </div>
</div>

<div id="menu4" *ngIf=" diNaacTable">
  <div class="table-container horizontal-scroll">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <!-- <th (click)="sortMe('category')">Category <span class="sortupdown"><i id="category1"
            class="fa fa-sort-up"></i><i id="category2" class="fa fa-sort-down"></i></span></th> -->
          <th scope="col">Name</th>

          <th scope="col" class="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of naacAffiliateList  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
          <td class="news-ellipsis">{{data.naacAffiliateName}}</td>
          <td class="col-display">{{data.naacAffiliateId}}</td>

          <td>
            <a id="editN{{i}}" (click)="editNaac(data,i)" class="edit-delete"><img src="assets/images/edit.png"
                class="image" title="Edit" alt="Angular Logo"></a>
            <a class="edit-delete" id=deleteDi{{i}} (click)="deleteDi(data.naacAffiliateId,'naac',i)"><img
                src="assets/images/delete.png" class="image" title="Delete" alt="Angular Logo"></a>
          </td>
        </tr>

      </tbody>
    </table>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElementsNaac}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageNaacChanged($event)">
    </pagination-controls>
  </div>
</div>

<p class="noDataFound" *ngIf="noNewsTable"> No data found </p>
<p class="noDataFound" *ngIf="noResourceTable"> No data found </p>
<p class="noDataFound" *ngIf="noReginalTbale"> No data found </p>
<p class="noDataFound" *ngIf="noNaacTable"> No data found </p>
